






























































import PlaceLogo from '@/components/ui/place/PlaceLogo/index.vue';
import { Component, Vue } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import Place from '@/models/place';
import { ONE_MINUTE_IN_SECONDS } from '@/utils/format/date';

@Component({
  name: 'TheHeader',
  components: {
    PlaceLogo,
  },
})
export default class TheHeader extends Vue {
  @State('selectedPlace', {
    namespace: 'place',
  })
  private selectedPlace!: Place;

  @Getter('activeOrders', {
    namespace: 'orderHistory',
  })
  private activeOrders!: any[];

  @State('utcNowInSeconds', {
    namespace: 'timer',
  })
  private utcNowInSeconds!: number;

  private get latestActiveOrder(): any {
    if (this.activeOrders.length === 0) {
      return null;
    }

    return this.activeOrders[this.activeOrders.length - 1];
  }

  private get minutesToEnd(): number {
    if (!this.latestActiveOrder) {
      return 0;
    }

    const secondsToEnd = this.latestActiveOrder.datetime - this.utcNowInSeconds;

    if (secondsToEnd <= ONE_MINUTE_IN_SECONDS) {
      return 0;
    }

    return Math.floor(secondsToEnd / ONE_MINUTE_IN_SECONDS);
  }

  private redirectToOrderStatus() {
    if (1 === this.activeOrders.length) {
      this.$router.push({
        name: 'orderView',
        params: {
          projectId: this.$route.params.projectId,
          orderId: this.latestActiveOrder.id,
        },
      });

      return;
    }

    this.$router.push({
      name: 'orderHistory',
      params: {
        projectId: this.$route.params.projectId,
      },
    });
  }
}
